"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isReportType = exports.LinkTypes = void 0;
exports.LinkTypes = {
    Location_Report: "Location Report",
    Flagged_Transaction: "Flagged Transaction",
    Ask_Request: "Ask Request",
    Period_Report: "Period Report"
};
function isReportType(type) {
    return type === exports.LinkTypes.Location_Report || type === exports.LinkTypes.Period_Report;
}
exports.isReportType = isReportType;
//# sourceMappingURL=Links.js.map